export default __webpack_public_path__ + "static/media/avatar_3.0664e574.png";